module.exports = __webpack_public_path__ + "img/quiebravistas.8d5348a3.gif";